import React, { FC, useEffect } from "react";
import { markup } from "./mock";
import "./index.scss";

interface Props {}

const setUpTab = ({ links }: { links: NodeListOf<HTMLElement> }) => {
  links.forEach(link => {
    const { parentElement, nextElementSibling, classList } = link;
    // @ts-ignore
    const { offsetHeight } = nextElementSibling;
    // @ts-ignore
    parentElement.style.maxHeight = `${
      parentElement && !parentElement.style.maxHeight
        ? nextElementSibling && offsetHeight + 60
        : parentElement && parentElement.style.maxHeight
    }px`;
    // @ts-ignore
    nextElementSibling.style.maxHeight = "0";
    // @ts-ignore
    classList.remove("collapsed");

    // @ts-ignore
    link.onclick = () => {
      // @ts-ignore
      const condition = classList.contains("collapsed");

      if (condition) {
        // @ts-ignore
        nextElementSibling.style.maxHeight = `${parentElement.style.maxHeight}`;
      } else {
        // @ts-ignore
        nextElementSibling.style.maxHeight = "0";
      }
    };
  });
};

export const StatisticsInit = () => {
  setUpTab({
    links: document.querySelectorAll(
      ".special-event-statistics .active .panel-heading"
    )
  });

  // Select the node that will be observed for mutations
  const targetNode = document.querySelector(".tab-body-wrapper");

  // Options for the observer (which mutations to observe)
  const config = { attributes: true, childList: true, subtree: true };

  // Callback function to execute when mutations are observed
  // @ts-ignore
  const callback = mutationList => {
    for (const mutation of mutationList) {
      if (
        mutation.attributeName == "class" &&
        mutation.target.classList.contains("active")
      ) {
        setUpTab({
          links: document.querySelectorAll(
            ".special-event-statistics .active .panel-heading"
          )
        });
      }
    }
  };

  // Create an observer instance linked to the callback function
  const observer = new MutationObserver(callback);

  // Start observing the target node for configured mutations
  // @ts-ignore
  typeof targetNode !== undefined &&
    targetNode !== null &&
    observer.observe(targetNode, config);
};

const Statistics: FC<Props> = () => {
  useEffect(() => {
    // its for BE
    const tabsNav = document.querySelector(".tab-headings");
    const tabsContent = document.querySelectorAll(
      ".tab-body-wrapper .tab-body"
    );
    if (!tabsNav) return;
    tabsNav.firstElementChild &&
      tabsNav.firstElementChild.classList.add("active");
    tabsContent[0].classList.add("active");
    tabsNav.addEventListener("click", (event: Event) => {
      const target = event.target as HTMLElement;
      const clickedTab = target.parentElement;
      const clickedIndex = [
        ...Array.prototype.slice.call(tabsNav.children)
      ].indexOf(clickedTab);
      tabsNav.querySelectorAll("li").forEach(tab => {
        tab.classList.remove("active");
      });
      if (!clickedTab) return;
      clickedTab.classList.add("active");

      const tabContent = tabsContent[clickedIndex];

      document
        .querySelectorAll(".tab-body-wrapper .tab-body")
        .forEach(content => {
          content.classList.remove("active");
        });

      tabContent.classList.add("active");
    });

    const links = document.querySelectorAll(".panel-heading");
    links.forEach(link => {
      link.addEventListener("click", event => {
        event.preventDefault();
        link.classList.toggle("collapsed");
      });
    });

    StatisticsInit();
  }, []);
  return (
    <div
      dangerouslySetInnerHTML={{
        __html: markup
      }}
    />
  );
};

export default Statistics;
